import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ngx-text-spinner',
  templateUrl: './text-spinner.component.html',
  styleUrls: ['./text-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextSpinnerComponent {
  @Input() text: string;
}
